const sleep = async ms => new Promise(resolve => setTimeout(resolve, ms));

export { sleep };
